import WsService from "../../WsService";
import RedemptionLookupResponse from "../../../domain/Transaction/inbound/RedemptionLookupResponse";
import RedemptionRequest from "../../../domain/Transaction/inbound/RedemptionRequest";
import RedemptionResponse from "../../../domain/Transaction/inbound/RedemptionResponse";
import UserSessionService from "../../UserSessionService";

const ENDPOINT_BASE = "/transactions/inbound";

export default class InboundTransactionRedemptionService {

    static lookup(registrationId, collectionPin) {

        let endpoint = ENDPOINT_BASE + "/lookup?registration-id=" + registrationId + "&collection-pin=" + collectionPin;

        let transactionHeaders = UserSessionService.retrieveTransactingHeaders();
        let headers = {
            ...transactionHeaders
        };

        return WsService.getWithHeaders(endpoint, {}, 200, headers).then(
            response => {
                return new RedemptionLookupResponse(response)
            },
            response => {
                return response;
            });
    }

    static requestRedemption(redemptionRequest) {

        let endpoint = ENDPOINT_BASE;
        let transactionHeaders = UserSessionService.retrieveTransactingHeaders();

        let headers = {
            ...transactionHeaders
        };

        let json = RedemptionRequest.toJson(redemptionRequest);
        return WsService.postWithHeaders(endpoint, json, 200, headers).then(
            response => {
                return new RedemptionResponse(response)
            },
            response => {
                return response;
            });
    }

    static requestRedemptionWithLimitIncrease(redemptionRequest) {

        let endpoint = ENDPOINT_BASE;
        let transactionHeaders = UserSessionService.retrieveTransactingHeaders();

        let headers = {
            ...transactionHeaders
        };

        let json =  RedemptionRequest.toJsonWithRequiredDocuments(redemptionRequest);
        return WsService.postWithHeaders(endpoint+"/limit-increase", json, 200, headers).then(
            response => {
                return new RedemptionResponse(response)
            },
            response => {
                return response;
            });
    }

    static requestRedemptionAndSignDeclaration(redemptionRequest, reportingDeclarationVersion) {
        let endpoint = ENDPOINT_BASE + '?reporting-declaration-version=' + reportingDeclarationVersion;
        let transactionHeaders = UserSessionService.retrieveTransactingHeaders();

        let headers = {
            ...transactionHeaders
        };

        let json = RedemptionRequest.toJson(redemptionRequest);
        return WsService.postWithHeaders(endpoint, json, 200, headers).then(
            response => {
                return new RedemptionResponse(response)
            },
            response => {
                return response;
            });
    }

    static requestRedemptionWithLimitIncreaseAndSignDeclaration(redemptionRequest, reportingDeclarationVersion) {
        let endpoint = ENDPOINT_BASE + '/limit-increase?reporting-declaration-version=' + reportingDeclarationVersion;
        let transactionHeaders = UserSessionService.retrieveTransactingHeaders();

        let headers = {
            ...transactionHeaders
        };

        let json =  RedemptionRequest.toJsonWithRequiredDocuments(redemptionRequest);
        return WsService.postWithHeaders(endpoint, json, 200, headers).then(
            response => {
                return new RedemptionResponse(response)
            },
            response => {
                return response;
            });
    }
}
